"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.HardwareAddressT = exports.HardwareAddress = void 0;
/**
 * A MAC address or a bluetooth address, or some other uniquely identifying address
 * associated with the endpoint that we are communicating with. If it doesn't take
 * up the full set of bytes, it is aligned towards the least significant bits.
 */
class HardwareAddress {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    addr() {
        return this.bb.readUint64(this.bb_pos);
    }
    static sizeOf() {
        return 8;
    }
    static createHardwareAddress(builder, addr) {
        builder.prep(8, 8);
        builder.writeInt64(addr);
        return builder.offset();
    }
    unpack() {
        return new HardwareAddressT(this.addr());
    }
    unpackTo(_o) {
        _o.addr = this.addr();
    }
}
exports.HardwareAddress = HardwareAddress;
class HardwareAddressT {
    constructor(addr = BigInt('0')) {
        this.addr = addr;
    }
    pack(builder) {
        return HardwareAddress.createHardwareAddress(builder, this.addr);
    }
}
exports.HardwareAddressT = HardwareAddressT;
